/**
 * Where the client shell's back arrow goes, and what its title says.
 *
 * Most sections sit directly under the client, so the arrow leaves the client entirely.
 * A few are drilled into *from* another section - the arrow should walk back one level to
 * the section you came from, not all the way out. Without this the shell would show its
 * own arrow and the nested section would need a second one, which is two back buttons
 * doing different things stacked on top of each other.
 */
const NESTED_SECTIONS = {
  "inventor-validation-history": { parentSlug: "inventors", title: "Validation History" },
};

export const CLIENT_LIST_PATH = "/kot";

/**
 * @param section  the last path segment, e.g. "inventors"
 * @param clientId the profile being viewed, absent while creating one
 * @returns `{ backTo, title }` - `title` is null for ordinary sections, where the shell
 *          keeps showing the client's name.
 */
export const resolveSectionHeader = (section, clientId) => {
  const nested = NESTED_SECTIONS[section];

  // Without a client there is nowhere to walk back to, so fall through to the list.
  if (!nested || !clientId) {
    return { backTo: CLIENT_LIST_PATH, title: null };
  }

  return {
    backTo: `/kot/client/edit/${clientId}/${nested.parentSlug}`,
    title: nested.title,
  };
};
